import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

const numberFormats = {
    'de': {
        currency: {
            style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', maximumSignificantDigits: 10
        },
        carat: {
            style: 'decimal',
            minimumFractionDigits: 3
        },
        mm: {
            style: 'decimal',
            minimumFractionDigits: 2
        }
    },
    'de-CH': {
        currency: {
            style: 'currency', currency: 'CHF', maximumSignificantDigits: 10
        },
        carat: {
            style: 'decimal',
            minimumFractionDigits: 3
        },
        mm: {
            style: 'decimal',
            minimumFractionDigits: 2
        }
    },
    'nl-NL': {
        currency: {
            style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', maximumSignificantDigits: 10
        },
        carat: {
            style: 'decimal',
            minimumFractionDigits: 3
        },
        mm: {
            style: 'decimal',
            minimumFractionDigits: 2
        }
    },
    'en-US': {
        currency: {
            style: 'currency', currency: 'USD', maximumSignificantDigits: 10
        },
        carat: {
            style: 'decimal',
            minimumFractionDigits: 3
        },
        mm: {
            style: 'decimal',
            minimumFractionDigits: 2
        }
    }
}

const dateTimeFormats = {
    'de': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        dateTime: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric'
        }
    },
    'nl-NL': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        dateTime: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric'
        }
    },
    'en': {
        short: {
            year: 'numeric', month: 'short', day: 'numeric'
        },
        long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        dateTime: {
            year: 'numeric', month: 'numeric', day: 'numeric',
            hour: 'numeric', minute: 'numeric'
        }
    }
}

export default new VueI18n({
    numberFormats,
    dateTimeFormats,
    locale: process.env.VUE_APP_I18N_LOCALE || 'de',
    fallbackLocale: {
        'en-DE': ['en'],
        'en-AT': ['en'],
        'en-CH': ['en'],
        'nl-NL': ['en'],
        'en-NL': ['en', 'nl-NL'],
        'default': process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de'
    },
    silentFallbackWarn: true,
    messages: loadLocaleMessages(),

})